export default __webpack_public_path__ + "static/years_watermark-f3bd28ad911c4ea1686fc003f7a4adb6.png";